/* load-more and infinite scroll */
$(document).ready(function () {
    $(document).on('click', '.js-load-more', function () {
        var $this = $(this);
        loadMoreProducts($this);
    });

    // $(window).on('load', function() {
    //     $(".js-load-more").click();
    // });
    
    var loadMoreProductsBtn = setInterval(function(){
        var jsLoadMoreBtn = document.getElementsByClassName('js-load-more');
        if (jsLoadMoreBtn.length > 0) { 
            clearInterval(loadMoreProductsBtn);
            $(".js-load-more").click();
        }
    },100);
});

function loadMoreProducts($this) {
    var totalPages = parseInt($('[data-all-pages]').val());
    var currentPage = parseInt($('[data-this-page]').val());
    var datacollurl = $('[data-coll-url]').val();
    $this.attr('disabled', true);
    $this.hide();
    $(".product_loader_div").show();
     
    setTimeout(function () {
        //$this.find('[load-more-text]').addClass('hide'); 
        var nextUrl = $('[data-next-link]').val();
        var current_page_new = currentPage + 1;
        var next_coll = currentPage + 2;
        $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function (responseHTML) {
                
                var next_page_new = current_page_new + 1;
                if (nextUrl.indexOf('page=') != -1) {
                    nextUrl = nextUrl.replace('page=' + current_page_new, 'page=' + next_page_new);
                } else {
                    if (nextUrl.indexOf('?') != -1) {
                        nextUrl = nextUrl + '&page=' + next_page_new;
                    } else {
                        nextUrl = nextUrl + '?page=' + next_page_new;
                    }
                }
                // console.log(nextUrl);
                $('[data-next-link]').val(nextUrl);
                $('[data-this-page]').val(current_page_new);
                $('#product-grid').append($(responseHTML).find('#product-grid').html());
            },
            complete: function () {
                if (current_page_new < totalPages) { 
                    $(".product_loader_div").hide();
                    $this.html('<span load-more-text>Load more</span>'); 
                    $this.attr('disabled', false);
                    $this.show();
                    //$this.find('[load-more-text]').removeClass('hide');
                }
                if (current_page_new >= totalPages) {
                    $this.find('[load-more-text]').parents('.load-more_wrap').hide();
                } else {
                    $('.js-load-more').click();
                }
            },
        });
    }, 1000);
}
/* end load-more and Infinite Scroll */